@if (fileUploaderService.buttonVisible()) {
  <button class="file-btn" (click)="fileUploaderService.open()">
    <i class="pi pi-file"></i>
  </button>
}
